import React, { useEffect, useState } from 'react';
import YouTube from 'react-youtube';
import Styled from './Style';

const Youtube = ({ src, isFullscreen }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [hasPlayed, setHasPlayed] = useState(false);
  const [playerEl, setPlayerEl] = useState();
  const videoId = src.split('?v=')[1];
  const options = {
    height: '315',
    width: '560',
    playerVars: {
      controls: 1,
      rel: 0,
      modestbranding: 1
    }
  };

  useEffect(() => {
    if (playerEl && isFullscreen) {
      playerEl.pauseVideo();
    }
  }, [isFullscreen, playerEl]);

  return (
    <Styled.YoutubeWrapper className={isPlaying && 'isPlaying'}>
      <YouTube
        videoId={videoId}
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        frameBorder="0"
        opts={options}
        onPlay={() => {
          setIsPlaying(true);
          setHasPlayed(true);
        }}
        onEnd={() => setIsPlaying(false)}
        onPause={() => setIsPlaying(false)}
        onReady={event => setPlayerEl(event.target)}
      />
      {!isPlaying ? (
        <div
          className={`cover ${hasPlayed && 'hasPlayed'}`}
          onClick={() => {
            if (playerEl) {
              playerEl.playVideo();
            }
          }}
        />
      ) : null}
    </Styled.YoutubeWrapper>
  );
};

const Video = ({ src, isFullscreen }) => {
  if (!src) {
    return null;
  }
  return (
    <Styled.Outer maxWidth={isFullscreen}>
      <Youtube src={src} isFullscreen={isFullscreen} />
    </Styled.Outer>
  );
};

export default Video;
